export const SetState = (onschedState, key, value) => 
  onschedState.setState(Object.assign(onschedState.state, { [key]: value }));
